import { render, staticRenderFns } from "./campaign.vue?vue&type=template&id=358ff788&scoped=true&"
import script from "./campaign.vue?vue&type=script&lang=js&"
export * from "./campaign.vue?vue&type=script&lang=js&"
import style1 from "./campaign.vue?vue&type=style&index=1&id=358ff788&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358ff788",
  null
  
)

export default component.exports